import React from "react"
import queryString from "query-string"
import { getCookieItem, setCookieItem } from "../utils/common"
import { useTheme } from "../context/ThemeContext"
import { planService } from "../services"

class HomePage extends React.Component {
  constructor(props) {
    super(props)
    this.setInitialState()
  }

  setInitialState() {
    const { query, theme, themeToggle } = this.props
    let affiliateId = getCookieItem("aId") || ""
    let promoCode = ""
    let pId = ""
    if (query) {
      const queryStringPart = query.indexOf("?") !== -1 ? query.substring(query.indexOf("?")) : ""
      const queriedTheme = queryString.parse(queryStringPart)
      promoCode = queriedTheme.promo || ""
      affiliateId = queriedTheme.aId || affiliateId
      const regex = /\/pricing\/([\w\d]+)\// // Matches any alphanumeric ID in the pricing segment
      const match = query.match(regex)
      if (match) {
        // Assuming IDs are numeric
        pId = match[1]
      } else {
        pId = ""
      }
      if (affiliateId) {
        setCookieItem("aId", affiliateId, 60)
      }
    }
    const updatedTheme = {
      ...theme,
      affiliateId,
      pId,
      promoCode,
    }
    themeToggle.setThemeState(updatedTheme)
    this.getPricingPlans(updatedTheme, themeToggle, pId)
  }

  componentDidMount() {
    this.bindAppCues()
    this.bindScript()
  }

  bindScript() {
    setTimeout(() => {
      if (typeof document != "undefined") {
        const script = document.createElement("script")
        script.innerHTML = `function loadScript(a){var b=document.getElementsByTagName("head")[0],c=document.createElement("script");c.type="text/javascript",c.src="https://tracker.metricool.com/resources/be.js",c.onreadystatechange=a,c.onload=a,b.appendChild(c)}loadScript(function(){beTracker.t({hash:"ac64bcf9e3aea8a4efac97c12e5a18e1"})});`
        document.head.prepend(script)
      }
    }, 5000)
  }

  bindAppCues() {
    setTimeout(() => {
      if (typeof window != "undefined" && window.Appcues) {
        window.Appcues.anonymous()
        console.log("Appcues")
      }
    }, 5000)
  }

  getPricingPlans(theme, themeToggle, pId) {
    planService
      .getMainSignUpPricingPageData(theme.promoCode, theme.affiliateId, pId)
      .then((pricingPlanResponse) => {
        if (pricingPlanResponse) {
          themeToggle.setThemeState({
            ...theme,
            showLoader: false,
            pricingPlanResponse,
          })
        }
      })
  }

  render() {
    return <></>
  }
}

const Home = ({ theme, location }) => {
  const themeToggle = useTheme()
  return (
    <HomePage query={location.href} theme={theme} themeToggle={themeToggle} />
  )
}

export default Home
